<template>
<div class="cn-timeline container">
    <div ref="slider" class="swiper-container">
        <div class="cn-timeline__pagination container">
            <div class="cn-timeline__wrapper">
                <div class="cn-timeline__years" ref="pagination"></div>
            </div>
        </div>
        <div class="cn-timeline__swiper-wrapper swiper-wrapper">
            <slot></slot>
        </div>
        <div class="cn-timeline__vertical">
            <slot></slot>
        </div>
    </div>
    <z-modal class="cn-timeline__modal" id="timelineVideoModal">
        <div>
            <z-caption
                tag="h3"
                size="l"
                decor-right
                uppercase
                class="cn-timeline__modal-title"
            >
                {{ videoData.title}}
            </z-caption>
            <z-video
                :src="videoData.src"
                :poster="videoData.poster"
                class="u-bottom-margin--xs"
            />
        </div>
    </z-modal>
</div>
</template>

<script>
import Swiper from 'swiper/dist/js/swiper.js'

export default {
    name: 'timeline',
    data () {
        return {
            slider: null,
            speed: 5000,
            isOnce: false,
            childLength: null,
            firstYear: 2021,
            videoData: {
                title: '',
                src: '',
                poster: ''
            }
        }
    },
    methods: {
        play (boolean) {
            if (boolean) {
                this.slider.autoplay.stop()
            } else {
                this.slider.autoplay.start()
            }
        },
        cycleByYears (element, year) {
            this.childLength = element.childNodes.length
            let yearFrom = Number(element.lastChild.dataset.year)
            const yearTo = Number(year)
            while (yearFrom < yearTo) {
                yearFrom++
                this.renderBulletYear(element, yearFrom)
            }
        },
        renderBulletYear (parent, year) {
            const button = document.createElement('button')
            button.classList.add('swiper-pagination-bullet', 'swiper-pagination-bullet--fake')
            button.innerHTML = `<span>${year}</span><span class="swiper-pagination-bullet-dot"></span>`
            parent.appendChild(button)
        }
    },
    watch: {
        childLength () {
            if (this.childLength < 6) {
                this.cycleByYears(this.$refs.pagination, 2031)
            }
        }
    },
    mounted () {
        this.slider = new Swiper(this.$refs.slider, {
            speed: this.speed,
            freeMode: {
                enabled: true,
                momentum: false,
                momentumBounce: false,
                momentumRatio: 0,
                momentumBounceRatio: 0,
                momentumVelocityRatio: 0
            },
            loop: false,
            spaceBetween: 0,
            slidesPerView: 'auto',
            autoplay: false,
            resizeObserver: false,
            updateOnWindowResize: false,
            pagination: {
                clickable: true,
                el: this.$refs.pagination,
                renderBullet: (index, className) => {
                    let year = this.firstYear + index
                    return `<button class="${className}" data-year="${year}"><span>${year}</span><span class="${className}-dot"></span></button>`
                }
            },
            on: {
                update: () => {
                    setTimeout(() => {
                        this.childLength = this.$refs.pagination.childNodes.length
                    }, 0)
                },
                beforeResize: () => {
                    setTimeout(() => {
                        this.childLength = this.$refs.pagination.childNodes.length
                    }, 0)
                }
            }
        })

        this.$nextTick(() => {
            setTimeout(() => {
                this.slider.setTranslate((this.slider.virtualSize - window.innerWidth) * -1)
                this.slider.updateProgress()
                this.slider.updateActiveIndex()
            }, 300)
        })

        this.$root.$bus.$on('open-modal', (data) => {
            this.videoData = {
                title: data.title,
                src: data.src,
                poster: data.poster
            }
        })
    }
}
</script>

<style lang="scss">
@mixin year-bullet {
    position: relative;
    padding-top: 4px;
    height: 54px;
    flex: 1 1;
    background: transparent;
    display: flex;
    flex-direction: column-reverse;
    align-items: center;

    &:before, &:after {
        content: '';
        position: absolute;
        top: 5.5px;
        width: calc(50% - 5px);
        height: 1px;
        background: $token-colors-text-disabled;
    }
    &:before {
        left: 0;
    }
    &:after {
        right: 0;
    }
}

.cn-timeline {

    & > .swiper-container {
        position: relative;
        width: 100vw;
        left: 50%;
        transform: translateX(-50%);
    }

    &__item {
        flex-shrink: 0;

        @include breakpoint (v-tablet) {
            width: 100%;
            max-width: 534px;
            margin: 0 auto;

            &--head {
                display: flex;
                gap: 15px;
            }
        }

        @include breakpoint (mobile) {
            width: max-content;

            &--head {
                gap: 8px;
                flex-direction: column;
            }
        }
    }

    &__pagination {
        display: flex;
        width: 100%;
        justify-content: space-between;
        margin-bottom: $token-spacers-s;
        gap: 100px;
        align-items: flex-end;

        @include breakpoint (v-tablet) {
            display: none;
        }
    }

    &__wrapper {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        flex: 1;
    }

    &__years {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        flex: 1;
    }

    &__title, &__subtitle {
        font-size: 64px;
        line-height: 100%;
        letter-spacing: -0.03em;
        background: linear-gradient(180deg, $token-colors-blue-50 0%, $token-colors-navy-blue 100%), $token-colors-white;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;

        @include breakpoint (v-tablet) {
            font-size: 48px;
        }
    }

    &__title {
        font-weight: 300;
    }

    &__subtitle {
        font-weight: 700;
        margin-bottom: $token-spacers-m;

        @include breakpoint (v-tablet) {
            margin-bottom: 24px;
        }
    }

    .z-button {
        font-weight: 600;
    }

    &__swiper-wrapper.swiper-wrapper {
        width: auto;
        height: auto;
        cursor: grab;
        @include breakpoint (v-tablet) {
            opacity: 0;
            height: 0;
            visibility: hidden;
        }

        &:active {
            cursor: grabbing;
        }

        & > .swiper-slide {
            padding: 0 60px;
            width: auto;
            height: auto;
            display: flex;
            gap: $token-spacers-3-xl;

            @include breakpoint (tablet) {
                padding: 0 24px;
                gap: $token-spacers-m;
            }
        }
    }
    &__vertical {
        display: none;
        flex-direction: column;
        gap: $token-spacers-m;

        @include breakpoint (v-tablet) {
            display: flex;
        }

        @include breakpoint (mobile) {
            gap: $token-spacers-s;
        }

        .swiper-slide {
            @include breakpoint (v-tablet) {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: $token-spacers-m;
            }

            @include breakpoint (mobile) {
                gap: $token-spacers-s;
            }
        }
    }

    &__modal-title.z-caption {
        color: $token-colors-blue;

        &.z-caption--decor-right:after {
            background: $token-colors-blue;
        }
    }

    .swiper-pagination-bullet {
        color: #5487B9;
        opacity: 1;
        transition: all 0.5s;

        @include year-bullet;

        span:not(.swiper-pagination-bullet-dot) {
            font-family: 'Proxima Nova Extra Condensed';
            font-size: 26px;
            font-weight: 400;
            line-height: 100%;
            color: currentColor;
            transition: all 0.5s;
            transform: translate(0, 15%);
        }

        &-dot {
            position: absolute;
            top: 4px;
            left: calc(50% - 2.5px);
            width: 5px;
            height: 5px;
            background: currentColor;
            border-radius: 50%;
            transition: all 0.5s;
        }

        &--fake {
            color: $token-colors-text-disabled;
            border: none;
            cursor: none;
            pointer-events: none;
        }

        &:first-of-type {
            &:before {
                display: none;
            }
        }
        &:last-of-type {
            &:after {
                display: none;
            }
        }
    }

    .swiper-pagination-bullet-active {
        span:not(.swiper-pagination-bullet-dot) {
            color: $token-colors-navy-blue;
            scale: 1.5;
            transform: translate(0, 2%);
        }

        & .swiper-pagination-bullet-dot {
            top: 0;
            left: calc(50% - 5.5px);
            width: 11px;
            height: 11px;
        }

        &:before, &:after {
            width: calc(50% - 8px);
        }
    }

    &.container {
        padding: 0;
    }
}
</style>
